"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getScoreFromNormalForReading = exports.getNormalFromAccumulatorForScoring = void 0;
const __1 = require("../..");
const getNormalFromAccumulatorForScoring = ({ accumulator, key }) => {
    return accumulator?.getNormal(key)?.mean;
};
exports.getNormalFromAccumulatorForScoring = getNormalFromAccumulatorForScoring;
const getScoreFromNormalForReading = ({ scoreDefinition, reading, normal }) => {
    // if there is no difference between the reading and the normal, bail (the score will always be `0`)
    if (reading === normal)
        return 0;
    /** if the reading is below the normal, use the `below` score definition coefficients */
    const below = reading < normal;
    /** absolute difference from normal, for this reading */
    const distance = Math.abs(reading - normal);
    /** select the above/below/default coefficients */
    const coefficients = (below ? scoreDefinition?.below : scoreDefinition?.above) ?? structuredClone(__1.DefaultScoreEquationCoefficients);
    /** do the actual computation */
    return (0, __1.ComputeScore)(coefficients, distance) * (below ? -1 : 1);
};
exports.getScoreFromNormalForReading = getScoreFromNormalForReading;
